import './FramesStrip.css'
import { StripItem } from '../../types'

interface FramesStripProps {
  items: StripItem[]
  loading: boolean
  onItemClick: (index: number) => void
}

const SKELETON_COUNT = 5

export default function FramesStrip({ items, loading, onItemClick }: FramesStripProps) {
  if (!loading && items.length === 0) return null

  return (
    <div className="frames-strip">
      <div className="frames-strip__row">
        {loading
          ? Array.from({ length: SKELETON_COUNT }).map((_, i) => (
              <div key={i} className="frames-strip__skeleton" />
            ))
          : items.map((item, index) => (
              <div
                key={item.id}
                className="frames-strip__thumb-wrapper"
                onClick={() => onItemClick(index)}
              >
                <img
                  className="frames-strip__thumb"
                  src={item.url}
                  alt={`Frame ${index + 1}`}
                />
                {item.kind === 'defect' && (
                  <span className="frames-strip__defect-badge" aria-hidden="true" />
                )}
              </div>
            ))}
      </div>
    </div>
  )
}
